import { message } from 'antd';

export const notifier = (
  type: 'info' | 'success' | 'error' | 'warning' | 'loading',
  content: string,
) => message[type](content);
